export { default } from './TemplateTab';
